export default "__VITE_ASSET__DsR7jW$p__"